import Api from '@/services/Api'

export default {
  fetch (params) {
    return Api().get('products?sku=' + (params.sku ? params.sku : '') + '&ean=' + (params.ean ? params.ean : '') + '&name=' + (params.name ? params.name : '') + '&page=' + (params.page ? params.page : ''))
  },

  add (params) {
    return Api().post('products', params)
  },

  update (params) {
    return Api().put('products/' + params.id, params)
  },

  get (params) {
    return Api().get('products/' + params.id)
  },

  delete (id) {
    return Api().delete('products/' + id)
  },

  report (params) {
    return Api().get('reports/products?sku=' + (params.sku ? params.sku : '') + '&ean=' + (params.ean ? params.ean : '') + '&name=' + (params.name ? params.name : '') + '&page=' + (params.page ? params.page : ''))
  },

  reportsku (params) {
    return Api().get('reports/product/sku/' + params.sku)
  },

  reportseries (params) {
    return Api().get('reports/product/series/' + params.sku + '?date1=' + params.date1 + '&date2=' + params.date2 + '&period=' + params.period)
  },

  reportdate (params) {
    return Api().get('reports/product/date/?website_id=' + params.website_id + '&sku=' + params.sku + '&date1=' + params.date1 + '&date2=' + params.date2)
  },

  reporttable (params) {
    var sku = params.sku ? params.sku : ''
    var name = params.name ? params.name : ''
    var brand = params.brand ? params.brand : ''
    var category = params.category ? params.category : ''
    console.log(params.page)
    return Api().get('reports/product/table/?sku=' + sku + '&name=' + name + '&brand=' + brand + '&category=' + category + '&page=' + (params.page ? params.page : ''))
  },

  cleanhistory (websiteId, productId) {
    return Api().get('products/cleanhistory/' + productId + '/' + websiteId)
  }

}



// WEBPACK FOOTER //
// ./src/services/ProductsService.js